import React from "react";
const VerticalMore = () => {
  return (
    <svg
      width="6"
      height="21"
      viewBox="0 0 6 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3 12.8625C4.24264 12.8625 5.25 11.8048 5.25 10.5C5.25 9.19524 4.24264 8.13751 3 8.13751C1.75736 8.13751 0.75 9.19524 0.75 10.5C0.75 11.8048 1.75736 12.8625 3 12.8625Z" />
      <path d="M3 20.7375C4.24264 20.7375 5.25 19.6798 5.25 18.375C5.25 17.0702 4.24264 16.0125 3 16.0125C1.75736 16.0125 0.75 17.0702 0.75 18.375C0.75 19.6798 1.75736 20.7375 3 20.7375Z" />
      <path d="M3 4.98751C4.24264 4.98751 5.25 3.92978 5.25 2.62501C5.25 1.32024 4.24264 0.262512 3 0.262512C1.75736 0.262512 0.75 1.32024 0.75 2.62501C0.75 3.92978 1.75736 4.98751 3 4.98751Z" />
    </svg>
  );
};

export default VerticalMore;
